import React, { useEffect } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { useAuthData } from "./../../authDataContext";
import { CookieConsent } from "./../CookieConsent";
import { Home } from "./../../pages/Home";
import { ConnectionSuccess } from "./../../pages/ConnectionSuccess";
import { ConnectionError } from "./../../pages/ConnectionError";

export function App() {
  const { setData } = useAuthData();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const resp = await axios.get(
          import.meta.env.VITE_API_URL + "/api/account",
          { withCredentials: true }
        );
        setData(resp.data);

        if (
          location.pathname === "/" &&
          (resp.data.externals.length > 0 || resp.data.games.length > 0)
        ) {
          navigate("/account");
        }
      } catch (err) {
        setData({ externals: [], games: [] });
        if (location.pathname === "/account") {
          navigate("/signout");
        } else if (location.pathname !== "/signin") {
          navigate("/signin");
        }
      }
    };

    //checkAuth();
  }, [navigate, location.pathname, setData]);

  return (
    <React.Fragment>
      <div id="page-loading-blocs-notifaction" className="page-preloader"></div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/connect/sanrio/success" element={<ConnectionSuccess />} />
        <Route path="/connect/sanrio/error" element={<ConnectionError />} />
      </Routes>
      <CookieConsent />
    </React.Fragment>
  );
}
